import { render, staticRenderFns } from "./ShopWealthRecordList.vue?vue&type=template&id=4f436bb1&scoped=true&lang=pug&"
import script from "./ShopWealthRecordList.vue?vue&type=script&lang=ts&"
export * from "./ShopWealthRecordList.vue?vue&type=script&lang=ts&"
import style0 from "./ShopWealthRecordList.vue?vue&type=style&index=0&id=4f436bb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f436bb1",
  null
  
)

export default component.exports